import { Badge, Box, Text, Timeline } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { StatusAlertFilledSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
import { usePanelStateAtom } from '../../../../hooks/rules-state';
import { useVerify } from '../../../../rule-mappers/shared/use-verify';
import { LayoutElementTimeline } from './layout-element-timeline.tsx';
export const InaccessibleLayoutElementContent = _ref => {
  let {
    element,
    status,
    elementIndex,
    pageId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    getGroupData
  } = usePanelStateAtom();
  const {
    verify
  } = useVerify({});
  const handleRescanClick = useCallback(async () => {
    const groupData = getGroupData(pageId);
    if (!groupData) {
      throw new Error(`Group data not found for pageId: ${pageId}.`);
    }
    await verify(groupData, []);
  }, [getGroupData, pageId, verify]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "B60",
    borderRadius: "6px",
    direction: "vertical",
    gap: "SP2",
    padding: "8px"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(Badge, {
    noPadding: true,
    showTooltip: false,
    size: "tiny",
    skin: "neutralStandard",
    type: "solid",
    uppercase: false
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "0 4px"
  }, t('accessibility-wizard.rules-list.content.generic.badge')))), status === ElementStatus.Failed && /*#__PURE__*/React.createElement(Timeline, {
    items: [{
      customPrefix: /*#__PURE__*/React.createElement(Box, {
        color: "R10"
      }, /*#__PURE__*/React.createElement(StatusAlertFilledSmall, {
        size: "18px"
      })),
      label: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        skin: "error",
        weight: "thin"
      }, t('accessibility-wizard.rules-list.inaccessible-layout.subtitle'))
    }]
  }), /*#__PURE__*/React.createElement(LayoutElementTimeline, {
    element: element,
    elementIndex: elementIndex,
    handleRescanClick: handleRescanClick,
    status: status
  })));
};
//# sourceMappingURL=inaccessible-layout-element-content.js.map